import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import classnames from 'classnames'
import ImmutableProptypes from 'react-immutable-proptypes'
import { OrderedMap, Map, List } from 'immutable'
import update from 'immutability-helper'
import { DragDropContext } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import { connect as reduxConnect } from 'react-redux'
import Modal from 'react-modal'
import { browserHistory } from 'react-router'
import Moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Cookies from 'js-cookie'

momentDurationFormatSetup(Moment)

import {
  getTodayItems,
  setTodayItemsOrder,
  deleteTodayItem,
  createTodayItem,
  editTodayItem,
  updateTodayItemDate,
  UPDATE_TODAY_ITEM_DATE,
  completeTodayItem,
  undoTodayItem,
} from '_modules/today-items/actions'
import { getTomorrowItems, createTomorrowItem } from '_modules/tomorrow-items/actions'
import { updateLastActivityAt } from '_modules/user/actions'
import { clearNotifications } from '_modules/notification/actions'
import { startTask, continueTask } from '_modules/current-task/actions'
import { getTasks, createLogEntryFromToday } from '_modules/log/actions'
import { addNewRoundOnTimer } from '_modules/counter/actions'
import { startTimer, decrementCounter, resetCounterRedux } from '_modules/counter/actions'
import { getCounterValue } from '_utils/counter'
import { objectToArray, deepCopyJSON } from '_utils/helperFunction'
import { sortByLastOccurenceAtJS, sortByOrder } from '_utils/sort'
import { USER_STATUS_TYPES } from '_utils/userStatusType'
import Socket from '_utils/socket'
import { createGoogleCalendarURL, createICalendarEvent } from '_utils/addToCalendar'

import styles from './styles.css'
import OrderingCard from './ordering-card'
import AddItemModal from './add-item-modal'
import CalendarModal from './calendar-modal'
import EventFormModal from './event-form-modal'

const mapStateToProps = ({
  user,
  todayItems,
  counter,
  settings,
  log,
  tomorrowItems,
  currentTask,
  loading,
  error,
}) => ({
  todayItems,
  tomorrowItems,
  counter,
  settings,
  log,
  user,
  currentTask,
  isLoadingUpdateTodayItemDate: !!loading.get(UPDATE_TODAY_ITEM_DATE.ACTION),
  updateTodayItemDateErrors: error.get(UPDATE_TODAY_ITEM_DATE.ACTION),
})

const mapDispatchToProps = {
  getTodayItems,
  setTodayItemsOrder,
  deleteTodayItem,
  createTodayItem,
  editTodayItem,
  startTask,
  completeTodayItem,
  startTimer,
  decrementCounter,
  resetCounterRedux,
  updateTodayItemDate,
  getTasks,
  createLogEntryFromToday,
  clearNotifications,
  updateLastActivityAt,
  getTomorrowItems,
  createTomorrowItem,
  continueTask,
  addNewRoundOnTimer,
  undoTodayItem,
}

@DragDropContext(HTML5Backend)
class TodayItems extends PureComponent {
  static propTypes = {
    todayItems: ImmutableProptypes.orderedMap,
    tomorrowItems: ImmutableProptypes.orderedMap,
    counter: ImmutableProptypes.map,
    settings: ImmutableProptypes.map,
    log: ImmutableProptypes.map,
    user: ImmutableProptypes.map,
    currentTask: ImmutableProptypes.map,
    getTodayItems: PropTypes.func.isRequired,
    setTodayItemsOrder: PropTypes.func.isRequired,
    deleteTodayItem: PropTypes.func.isRequired,
    createTodayItem: PropTypes.func.isRequired,
    editTodayItem: PropTypes.func.isRequired,
    startTask: PropTypes.func.isRequired,
    completeTodayItem: PropTypes.func.isRequired,
    startTimer: PropTypes.func.isRequired,
    decrementCounter: PropTypes.func.isRequired,
    updateTodayItemDate: PropTypes.func.isRequired,
    getTasks: PropTypes.func.isRequired,
    createLogEntryFromToday: PropTypes.func.isRequired,
    clearNotifications: PropTypes.func.isRequired,
    updateLastActivityAt: PropTypes.func.isRequired,
    getTomorrowItems: PropTypes.func.isRequired,
    createTomorrowItem: PropTypes.func.isRequired,
    continueTask: PropTypes.func.isRequired,
    addNewRoundOnTimer: PropTypes.func.isRequired,
    undoTodayItem: PropTypes.func.isRequired,
  }

  static defaultProps = {
    todayItems: new OrderedMap(),
    tomorrowItems: new OrderedMap(),
    counter: new Map(),
    settings: new Map(),
    log: new Map(),
    user: new Map(),
    currentTask: new Map(),
  }

  undoToastId = null

  state = {
    cards: [],
    isModalOpen: false,
    modalName: '',
    modalDatetime: null,
    modalDuration: 0.5,
    modalId: undefined,
    showCompleted: false,
    isAddItemModal: false,
    isCalendarModal: false,
    isEventFormModal: false,
  }

  componentWillMount() {
    if (localStorage.getItem('todayShowCompleted') === undefined) {
      localStorage.setItem('todayShowCompleted', false)
    }
    Modal.setAppElement('body')
    this.props.getTodayItems()
    this.props.getTomorrowItems()
    this.props.getTasks()
    this.getCards(objectToArray(this.props.todayItems.toJS()))
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.user.get('lastActivityAt') !== nextProps.user.get('lastActivityAt')) {
      this.props.getTodayItems()
      this.props.getTasks()
    }
    this.getCards(objectToArray(nextProps.todayItems.toJS()))

    if (this.props.isLoadingUpdateTodayItemDate && !nextProps.isLoadingUpdateTodayItemDate) {
      if (nextProps.updateTodayItemDateErrors) {
        this.props.displayError(nextProps.updateTodayItemDateErrors)
      }
    }
  }

  componentWillUnmount() {
    toast.dismiss(this.undoToastId)

    this.props.clearError()
  }

  onKeyPress = event => {
    if (event.key === 'Enter') {
      this.onConfirmModal(event)
    }
  }

  onAddClick = e => {
    e.preventDefault()

    this.setState({
      isModalOpen: true,
      isAddItemModal: true,
      modalName: '',
      modalId: undefined,
    })
  }

  onMoreClick = () => {
    this.props.getTodayItems()
    this.toggleCompleted()
  }

  onRefreshClick = () => {
    this.props.getTodayItems()
    this.props.getTasks()
  }

  onReconcileClick = () => {
    browserHistory.push('/reconcile')
  }

  onModalChange = e => {
    e.preventDefault()
    const { id, value } = e.target
    this.setState({
      modalName: value,
    })
  }

  onDatetimeChange = modalDatetime => {
    this.setState({ modalDatetime })
  }

  onDurationChange = e => {
    e.preventDefault()
    const { id, value } = e.target
    this.setState({
      modalDuration: value,
    })
  }

  resetState = () => {
    this.setState({
      isModalOpen: false,
      modalName: '',
      modalDatetime: null,
      modalDuration: 0.5,
      modalId: undefined,
      isAddItemModal: false,
      isCalendarModal: false,
      isEventFormModal: false,
    })
  }

  onCancelModal = e => {
    e.preventDefault()
    this.props.clearError()

    this.setState({
      isModalOpen: false,
      modalName: '',
      modalId: undefined,
      isAddItemModal: false,
      isCalendarModal: false,
      isEventFormModal: false,
    })
  }

  onConfirmModal = e => {
    if (e) {
      e.preventDefault()
    }
    this.props.clearError()

    const { modalName, modalId, cards, isEventFormModal } = this.state

    if (isEventFormModal) {
      this.handleCalendarClick('ics')
      return
    }

    if (!modalName) {
      this.props.displayError('Enter a today item name')
      return
    }

    const foundSameCard = cards.filter(
      x =>
        x.name.toLowerCase() === modalName.toLowerCase() &&
        new Date(x.keptAt).toDateString() === new Date().toDateString()
      // x.active === true
    )

    if (foundSameCard.length > 0 && !modalId) {
      this.props.displayError('Today item with the same name already exists')
      return
    }

    if (modalName.indexOf('@BE') === 0) {
      const message = modalName.substring(4).trim()
      this.props.handleShowDesktopNotification(message)
    }

    if (modalId) {
      this.modifyTodayItem()
    } else {
      this.createTodayItem()
    }

    this.setState({
      isModalOpen: false,
      isAddItemModal: false,
      isCalendarModal: false,
      isEventFormModal: false,
    })
  }

  getCards = todayArr => {
    this.setState({ cards: todayArr })
  }

  playCard = id => {
    const { counter, currentTask, settings } = this.props
    const { cards } = this.state

    if (counter.get('intervalId') !== null) return

    const card = cards.filter(c => c._id === id)[0]
    const { name, logEntry, duration } = card
    let action = 'start'

    const flexibleTime = settings.get('flexibleTime')

    // if logentry and status is switched, then continue
    if (logEntry && card.status === 3) {
      action = 'continue'
    }

    browserHistory.push({
      pathname: '/',
      state: {
        name,
        action,
        logEntry,
        flexibleTime,
        duration,
        type: 3,
      },
    })
  }

  editCard = id => {
    const { cards } = this.state
    const card = cards.filter(c => c._id === id)[0]

    this.setState({
      isModalOpen: true,
      isAddItemModal: true,
      modalName: card.name,
      modalId: card._id,
    })
  }

  checkCard = id => {
    const { cards } = this.state
    const card = cards.filter(c => c._id === id)[0]
    const time = new Date()

    // if complete, today screen to update
    // if not complete, affects log screen

    if (card.status === 2) {
      const payload = {
        name: card.name,
        type: 3,
        time,
        status: card.status,
        logEntry: card.logEntry,
        todayItem: card._id,
      }
      this.props.completeTodayItem(payload)
      this.props.updateLastActivityAt({
        lastActivityAt: new Date(),
      })
    } else {
      let payload = {
        name: card.name,
        type: 3,
        time,
        status: card.status,
        logEntry: card.logEntry,
        todayItem: card._id,
      }
      if (card.status === 0) {
        payload.time = card.keptAt
      }
      this.props.createLogEntryFromToday(payload)
      this.props.updateLastActivityAt({
        lastActivityAt: new Date(),
      })
    }
  }

  toggleModal = () => {
    this.props.clearError()
    this.setState({
      isModalOpen: !this.state.isModalOpen,
    })
  }

  toggleCompleted = () => {
    const showCompleted = JSON.parse(localStorage.getItem('todayShowCompleted'))
    localStorage.setItem('todayShowCompleted', !showCompleted)
    // this.setState({
    //   showCompleted: !this.state.showCompleted,
    // })
  }

  saveOrdering = () => {
    const { cards } = this.state

    const payload = cards.reduce((obj, item, index) => {
      const newObj = { ...obj }
      newObj[item._id] = index
      return newObj
    }, {})

    this.props.setTodayItemsOrder(payload)
    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
  }

  moveCard = (dragIndex, hoverIndex) => {
    const { cards } = this.state

    const dragCard = cards[dragIndex]

    this.setState(
      update(this.state, {
        cards: {
          $splice: [[dragIndex, 1], [hoverIndex, 0, dragCard]],
        },
      })
    )
  }

  shiftCard = id => {
    this.props.updateTodayItemDate(id)
    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
  }

  undoCard = () => {
    this.props.undoTodayItem()
    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
    toast.dismiss(this.undoToastId)
  }

  deleteCard = id => {
    this.props.deleteTodayItem(id)

    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })

    const UndoMsg = ({ closeToast }) => (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-around',
        }}
      >
        <div style={{ color: 'white', fontSize: 14, flex: 1, paddingLeft: 7 }}>
          Today Item Trashed
        </div>
        <button className={styles.undoButton} onClick={() => this.undoCard()}>
          <div style={{ color: '#F9DC5C', fontSize: 13 }}>UNDO</div>
        </button>
        <button onClick={closeToast} style={{ color: 'rgba(255,255,255,0.5)', fontSize: 12 }}>
          X
        </button>
      </div>
    )

    if (!toast.isActive(this.undoToastId)) {
      this.undoToastId = toast(<UndoMsg />, {
        className: styles['black-background'],
        position: toast.POSITION.BOTTOM_LEFT,
        autoClose: false,
        closeOnClick: false,
        closeButton: false,
      })
    }
  }

  createTomorrowItemCard = (id, sectionId) => {
    const { cards } = this.state
    const card = cards.filter(c => c._id === id)[0]

    const { tomorrowItems } = this.props
    // find dupe in tasks page
    const dupe = tomorrowItems.find(ele => ele.name === card.name && ele.section === sectionId)
    if (dupe) {
      toast.error('Task already exists', {
        position: 'top-center',
        autoClose: 2000,
      })
      return
    }

    // find last order in tomorrowItems
    const order = tomorrowItems.reduce((prevVal, c) => {
      if (c.order > prevVal) {
        return c.order
      }
      return prevVal
    }, 0)

    const payload = {
      name: card.name,
      order: order + 1,
      section: sectionId,
    }

    this.props.createTomorrowItem(payload)
    this.props.getTomorrowItems()
    this.props.deleteTodayItem(id)
    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })

    // notify success
    toast.success(`Added ${card.name} to Tasks`, {
      position: 'top-center',
      autoClose: 2000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: false,
    })
  }

  modifyTodayItem = () => {
    const { modalName: name, modalId: id, cards } = this.state

    const card = cards.filter(c => c._id === id)[0]
    const payload = {
      name,
      order: card.order,
    }
    this.props.editTodayItem(id, payload)

    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
  }

  createTodayItem = () => {
    const { modalName: name, cards } = this.state

    const order = cards.reduce((prevVal, card) => {
      if (card.order > prevVal) {
        return card.order
      }
      return prevVal
    }, 0)

    const payload = {
      name,
      order: order + 1,
    }

    this.props.createTodayItem(payload)

    this.props.updateLastActivityAt({
      lastActivityAt: new Date(),
    })
  }

  onCalendarClick = payload => {
    const { name } = payload
    this.setState({
      isCalendarModal: true,
      isModalOpen: true,
      modalName: name,
    })
  }

  handleCalendarClick = type => {
    const { modalName: name, modalDatetime: datetime, modalDuration: duration } = this.state
    switch (type) {
      case 'gcal': {
        const url = createGoogleCalendarURL({ name })
        window.open(url, '_blank')
        this.resetState()
        break
      }
      case 'apple':
        this.setState({
          isCalendarModal: false,
          isEventFormModal: true,
          modalDatetime: new Moment().subtract(1, 'hours'),
        })
        break
      case 'outlook':
        this.setState({
          isCalendarModal: false,
          isEventFormModal: true,
          modalDatetime: new Moment().subtract(1, 'hours'),
        })
        break
      case 'ics':
        createICalendarEvent({ name, datetime, duration })
        this.resetState()
        break
      default:
    }
  }

  timer = () => {
    this.props.decrementCounter()
  }

  filterToday = element => new Date(element.keptAt).toDateString() === new Date().toDateString()

  filterMore = cards => {
    const notToday = cards.filter(c => !this.filterToday(c))
    const notTodayIncomp = notToday.filter(task => task.status !== 2)
    return notTodayIncomp.reduce((groups, item) => {
      const day = Moment(item.keptAt).format('YYYY-MM-DD')
      if (groups.get(day)) {
        return groups.set(day, groups.get(day).push(item))
      }
      return groups.set(day, List.of(item))
    }, new OrderedMap())
  }

  renderCards = group =>
    group.map(card => {
      const { cards } = this.state
      const arrIndex = cards.findIndex(x => x._id === card._id)
      const hilight = this.props.location.state && this.props.location.state.id === card._id
      return (
        <li
          key={card._id}
          className={classnames(
            styles['Grid-cell'],
            styles.pause,
            hilight && styles.hilight,
            this.props.counter.get('status') === 'in progress' &&
              this.props.counter.get('name').toLowerCase() === card.name.toLowerCase() &&
              new Date(card.keptAt).toDateString() === new Date().toDateString() &&
              styles.disabled
          )}
        >
          <OrderingCard
            index={arrIndex}
            moveCard={this.moveCard}
            id={card._id}
            saveOrdering={this.saveOrdering}
            deleteCard={this.deleteCard}
            editCard={this.editCard}
            playCard={this.playCard}
            checkCard={this.checkCard}
            shiftCard={this.shiftCard}
            createTomorrowItemCard={this.createTomorrowItemCard}
            createCalendarCard={this.onCalendarClick}
            name={card.name}
            status={card.status}
            date={card.keptAt}
          />
        </li>
      )
    })

  renderCompleted = (groups, date) => {
    if (!this.state.showCompleted) {
      return null
    }
    return (
      <div key={date} className={classnames(styles['Grid-alignCenter'])}>
        <div className={classnames(styles.date, styles['Grid-alignCenter'])}>
          {Moment(date).calendar(null, {
            sameDay: '[Today]',
            nextDay: '[Tomorrow]',
            nextWeek: 'MMM Do',
            lastDay: '[Yesterday]',
            lastWeek: 'MMM Do',
            sameElse: 'MMM Do',
          })}
        </div>
        <ul className={classnames(styles['Grid-alignCenter'])}>{this.renderCards(groups)}</ul>
      </div>
    )
  }

  renderList = cards => {
    const today = cards.filter(this.filterToday)
    const incomplete = today.filter(task => task.status !== 2)
    const complete = today.filter(task => task.status === 2)
    // either show incomplete, incomplete with complete at bottom, or incomplete with more at bottom

    return (
      <div className={classnames(styles['Grid-cell'], styles['list-container'])}>
        <div className={classnames(styles.list, styles['Grid--alignCenter'])}>
          <ul>{this.renderCards(incomplete)}</ul>
          {JSON.parse(localStorage.getItem('todayShowCompleted')) && complete.length > 0 && (
            <div>
              <div className={classnames(styles.date, styles['Grid--alignCenter'])}>Completed</div>
              <ul>{this.renderCards(complete)}</ul>
            </div>
          )}
        </div>
      </div>
    )
  }

  divRef = null

  render() {
    const {
      cards,
      isModalOpen,
      modalName,
      modalDatetime,
      modalDuration,
      isCalendarModal,
      isAddItemModal,
      isEventFormModal,
    } = this.state
    const calendars = [
      {
        name: 'Google Calendar',
        function: () => this.handleCalendarClick('gcal'),
        icon: 'fa fa-google',
      },
      {
        name: 'Outlook Calendar',
        function: () => this.handleCalendarClick('outlook'),
        icon: 'fa fa-windows',
      },
      {
        name: 'Apple Calendar',
        function: () => this.handleCalendarClick('apple'),
        icon: 'fa fa-apple',
      },
    ]

    return (
      <div
        ref={div => (this.divRef = div)}
        className={classnames(styles.Grid, styles['Grid--alignCenter'], styles.main)}
      >
        <div className={classnames(styles['Grid-cell'], styles.title)}>
          What I Intend To Accomplish Today
        </div>
        {this.renderList(cards)}
        <div className={classnames(styles['Grid-cell'], styles['u-sizeFit'])}>
          <button className={classnames(styles['add-button'])} onClick={this.onAddClick}>
            Add Item
          </button>
          <button className={classnames(styles['add-button'])} onClick={this.onMoreClick}>
            {JSON.parse(localStorage.getItem('todayShowCompleted'))
              ? 'Hide Complete'
              : 'Show Complete'}
          </button>
          <button className={classnames(styles['add-button'])} onClick={this.onRefreshClick}>
            Refresh
          </button>
          <button className={classnames(styles['add-button'])} onClick={this.onReconcileClick}>
            Reconcile
          </button>
        </div>
        <Modal
          isOpen={isModalOpen}
          className={classnames(styles.modal)}
          overlayClassName={classnames(styles.overlay)}
          onRequestClose={this.onCancelModal}
          shouldCloseOnOverlayClick
          bodyOpenClassName={classnames(styles['disable-body-scroll'])}
        >
          {isAddItemModal && (
            <AddItemModal
              inputValue={modalName}
              inputOnChange={this.onModalChange}
              inputPlaceholder="Name"
              inputKeyPress={this.onKeyPress}
              button1Name="SAVE"
              button2Name="CANCEL"
              button1Function={this.onConfirmModal}
              button2Function={this.onCancelModal}
            />
          )}
          {isCalendarModal && <CalendarModal calendars={calendars} />}
          {isEventFormModal && (
            <EventFormModal
              nameValue={modalName}
              nameOnChange={this.onModalChange}
              dateValue={modalDatetime}
              dateOnChange={this.onDatetimeChange}
              durationValue={modalDuration}
              durationOnChange={this.onDurationChange}
              button1Name="SAVE"
              button2Name="CANCEL"
              button1Function={this.onConfirmModal}
              button2Function={this.resetState}
            />
          )}
        </Modal>
      </div>
    )
  }
}

export default reduxConnect(mapStateToProps, mapDispatchToProps)(TodayItems)



// WEBPACK FOOTER //
// ./src/views/today-items/index.js